import { useTranslation } from "react-i18next"
import { AddtionalEntity } from "../../Objects/Addtional/AddtionalEntity"
import { addtionalMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"

export const useGetAddtional = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetAddtional = async (onSuccess: any, rote: string = API_ROUTES.ADDTIONAL.GET_ALL) => {
    enableLoad()

    try {
      const response = await GetRequest<AddtionalEntity[]>(rote)

      if (response.success) {
        const temp = response.data?.map((ss) => new AddtionalEntity(ss)) ?? []

        addtionalMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetAddtional,
  }
}
